import React from 'react';
import { Input } from './ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

/**
 * Reusable Image Size Controls component
 * Used in: Image block, Columns block images, Image+Text layouts
 */
const ImageSizeControls = ({ 
  sizeMode = 'width', 
  width = 200, 
  height = 200, 
  align = 'center',
  onSizeModeChange,
  onWidthChange,
  onHeightChange,
  onAlignChange,
  compact = false 
}) => {
  if (compact) {
    // Compact single-row layout for tight spaces
    return (
      <div className="flex gap-2 items-center flex-wrap">
        <Select value={sizeMode} onValueChange={onSizeModeChange}>
          <SelectTrigger className="w-24 h-7 text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="width">Width</SelectItem>
            <SelectItem value="height">Height</SelectItem>
            <SelectItem value="custom">Custom</SelectItem>
          </SelectContent>
        </Select>
        
        {sizeMode === 'custom' ? (
          <div className="flex items-center gap-1">
            <span className="text-xs text-slate-500">W:</span>
            <Input
              type="number"
              value={width}
              onChange={(e) => onWidthChange(parseInt(e.target.value) || 200)}
              className="w-14 h-7 text-xs"
              min="50"
              max="1200"
            />
            <span className="text-xs text-slate-500">H:</span>
            <Input
              type="number"
              value={height}
              onChange={(e) => onHeightChange(parseInt(e.target.value) || 200)}
              className="w-14 h-7 text-xs"
              min="50"
              max="1200"
            />
            <span className="text-xs text-slate-400">px</span>
          </div>
        ) : sizeMode === 'width' ? (
          <div className="flex items-center gap-1">
            <Input
              type="number"
              value={width}
              onChange={(e) => onWidthChange(parseInt(e.target.value) || 200)}
              className="w-16 h-7 text-xs"
              min="50"
              max="1200"
            />
            <span className="text-xs text-slate-400">px</span>
          </div>
        ) : (
          <div className="flex items-center gap-1">
            <Input
              type="number"
              value={height}
              onChange={(e) => onHeightChange(parseInt(e.target.value) || 200)}
              className="w-16 h-7 text-xs"
              min="50"
              max="1200"
            />
            <span className="text-xs text-slate-400">px</span>
          </div>
        )}

        <Select value={align} onValueChange={onAlignChange}>
          <SelectTrigger className="w-20 h-7 text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="left">Left</SelectItem>
            <SelectItem value="center">Center</SelectItem>
            <SelectItem value="right">Right</SelectItem>
          </SelectContent>
        </Select>
      </div>
    );
  }

  // Standard layout
  return (
    <div className="flex gap-3 items-center flex-wrap text-sm">
      <div className="flex items-center gap-2">
        <span className="text-xs text-slate-500">Size:</span>
        <Select value={sizeMode} onValueChange={onSizeModeChange}>
          <SelectTrigger className="w-28 h-8 text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="width">By Width</SelectItem>
            <SelectItem value="height">By Height</SelectItem>
            <SelectItem value="custom">Custom (W×H)</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      {sizeMode === 'custom' ? (
        <div className="flex items-center gap-1">
          <span className="text-xs text-slate-500">W:</span>
          <Input
            type="number"
            value={width}
            onChange={(e) => onWidthChange(parseInt(e.target.value) || 200)}
            className="w-16 h-8 text-sm"
            min="50"
            max="1200"
          />
          <span className="text-xs text-slate-500">H:</span>
          <Input
            type="number"
            value={height}
            onChange={(e) => onHeightChange(parseInt(e.target.value) || 200)}
            className="w-16 h-8 text-sm"
            min="50"
            max="1200"
          />
          <span className="text-xs text-slate-400">px</span>
        </div>
      ) : sizeMode === 'width' ? (
        <div className="flex items-center gap-1">
          <span className="text-xs text-slate-500">W:</span>
          <Input
            type="number"
            value={width}
            onChange={(e) => onWidthChange(parseInt(e.target.value) || 200)}
            className="w-20 h-8 text-sm"
            min="50"
            max="1200"
          />
          <span className="text-xs text-slate-400">px</span>
        </div>
      ) : (
        <div className="flex items-center gap-1">
          <span className="text-xs text-slate-500">H:</span>
          <Input
            type="number"
            value={height}
            onChange={(e) => onHeightChange(parseInt(e.target.value) || 200)}
            className="w-20 h-8 text-sm"
            min="50"
            max="1200"
          />
          <span className="text-xs text-slate-400">px</span>
        </div>
      )}

      <div className="flex items-center gap-2">
        <span className="text-xs text-slate-500">Align:</span>
        <Select value={align} onValueChange={onAlignChange}>
          <SelectTrigger className="w-24 h-8 text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="left">Left</SelectItem>
            <SelectItem value="center">Center</SelectItem>
            <SelectItem value="right">Right</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default ImageSizeControls;
